// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__13DW8","footer":"styles_footer__1pOOf","passCodeTooltip":"styles_passCodeTooltip__3IRqh"};